declare const jQuery: any;
const $ = jQuery;

export function initSearchPopup()
{
	const $forms = $(`[data-popup="search"] form, form.search-form`);
	if ($forms.length === 0)
	{
		return;
	}
	$forms.on("submit", function (ev) {
		return !!$.trim($(this).find(`input[type="text"],input[type="search"]`).val() || "");
	});
}
